import React from 'react';
import { HeroSection } from './HeroSection';
import { ProblemSection } from './ProblemSection';
import { FailedMethodsSection } from './FailedMethodsSection';
import { MechanismSection } from './MechanismSection';
import { DeliverablesSection } from './DeliverablesSection';
import { AudienceSection } from './AudienceSection';
import { HowItWorksSection } from './HowItWorksSection';
import { ProofSection } from './ProofSection';
import { FAQSection } from './FAQSection';
import { OfferSection } from './OfferSection';
import { FooterSection } from './FooterSection';
export function LandingPage() {
  return <main className="min-h-screen w-full overflow-hidden" data-id="element-204">
      <HeroSection data-id="element-205" />
      <ProblemSection data-id="element-206" />
      <FailedMethodsSection data-id="element-207" />
      <MechanismSection data-id="element-208" />
      <DeliverablesSection data-id="element-209" />
      <AudienceSection data-id="element-210" />
      <HowItWorksSection data-id="element-211" />
      <ProofSection data-id="element-212" />
      <FAQSection data-id="element-213" />
      <OfferSection data-id="element-214" />
      <FooterSection data-id="element-215" />
    </main>;
}